import { render } from "./MainHeadingBlock.vue?vue&type=template&id=1fe2954f&scoped=true"
import script from "./MainHeadingBlock.vue?vue&type=script&lang=js"
export * from "./MainHeadingBlock.vue?vue&type=script&lang=js"

import "./MainHeadingBlock.vue?vue&type=style&index=0&id=1fe2954f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2954f"]])

export default __exports__